export const CSRFToken = {
  computed: {
    _csrf() {
      if (window.tom && window.tom.conf && window.tom.conf.csrfToken) {
        return window.tom.conf.csrfToken;
      }

      const inputElement = document.querySelector('input[name="csrf_token"]');
      if (inputElement && inputElement.value) {
        return inputElement.value;
      }

      const metaElement = document.querySelector('meta[name="csrf-token"]');
      if (!metaElement) {
        return;
      }

      return metaElement.getAttribute('content');
    }
  }
};
